import { CardColorSwatches } from '@apps/card/components/CardColorSwatches';
import type { ColorwayOption } from '@apps/card/routes/CardCustomizer/CardCustomizer.types';
import { useTranslation } from '@shared/core';
import { Flex, TextV2 } from '@withjoy/joykit';
import React from 'react';

type Props = Readonly<{
  options?: ReadonlyArray<ColorwayOption>;
  selectedColorwayId?: string;
  onSelect?: (id: string) => void;
  /** Applied only when the selector actually renders (no phantom gap when null). */
  marginBottom?: number;
}>;

/**
 * Shared "Color" swatch selector rendered on the PDP customization pane for
 * every format that carries colorways (print + premium digital). Renders
 * nothing when the template has no colorways or no selection handler.
 */
export const ColorwaySelector = ({ options, selectedColorwayId, onSelect, marginBottom }: Props) => {
  const { tq } = useTranslation('stationery');
  if (!options || selectedColorwayId === undefined || !onSelect) {
    return null;
  }
  return (
    <Flex
      flexDirection="column"
      rowGap={3}
      marginBottom={marginBottom}
    >
      <Flex
        columnGap={4}
        alignItems="center"
      >
        <TextV2 typographyVariant="hed1">{tq`Color`}</TextV2>
        <TextV2
          typographyVariant="body1"
          color="mono12"
          textTransform="capitalize"
        >
          {selectedColorwayId}
        </TextV2>
      </Flex>
      <CardColorSwatches
        options={options}
        selectedId={selectedColorwayId}
        onSelect={onSelect}
        size="large"
      />
    </Flex>
  );
};
